import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { storesApi } from "../../api";
import { IProduct, IDetailProduct } from "../types";



type ProductsState = {
    loading: boolean
    error: null | string
    products: null | IProduct[]
    detail: null | IDetailProduct
}

const initialState: ProductsState = {
    error: null,
    loading: false,
    products: null,
    detail: null,
}


export const fetchByProducts = createAsyncThunk(
    'products/fetchByProducts',
    async (_, { rejectWithValue }) => {
        try {
        const res = await storesApi.getProducts()
               return res.data.data;
            } catch (error: any) {
               return rejectWithValue(error.response?.data || 'Ошибка сервера');
           }
     
    })

export const fetchByDetailProduct = createAsyncThunk<IDetailProduct, number, { rejectValue: string }>(
    'products/fetchByDetailProduct',
    async (id, { rejectWithValue }) => {
        try {
            const res = await storesApi.getDetailProduct(id)
            return res.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Ошибка сервера');
        }
    })



const productsSlice = createSlice({
    name: 'products',
    initialState,
    reducers: {},
    extraReducers: ({ addCase }) => {
        addCase(fetchByProducts.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        addCase(fetchByProducts.fulfilled, (state, action) => {
            state.products = action.payload;
            state.loading = false;
        });
        addCase(fetchByProducts.rejected, (state) => {
            state.loading = false;
            state.error = 'Ошибка сервера!';
        });
        addCase(fetchByDetailProduct.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        addCase(fetchByDetailProduct.fulfilled, (state, action) => {
            state.detail = action.payload;
            state.loading = false;
        });
        addCase(fetchByDetailProduct.rejected, (state) => {
            state.loading = false;
            state.error = 'Ошибка сервера!';
        });

    },
})


export default productsSlice.reducer

